import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import PageConH5 from '@/componentsH5/productSolar/solarpanel_100w';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import PageConPc from '@/components/productSolar/solarpanel_100w';
import { useSupportData } from '@/utils/hooks';
import Annotation from '@/components/Annotation';

// 产品详情页参数
const productName = '100w-rigid-solar-panel';
const generalKey = 'product_sp_100w_rigid_solar_panel';

const whiteLocaleList = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'cis', 'sa', 'eu', 'br', 'mx', 'nl'];
export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useLang } = useGlobal();
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const [theme, setTheme] = useState('');
    const router = useRouter();
    const { t } = useLang('100wrigidsolarpanel');
    const { locale = 'us' } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // 如果不存在该页面,返回404
    // if (!productMsg.generalKey && gloproductlist.length && typeof window !== 'undefined') {
    //     return router.push(`${location.origin}/${router.locale}/404`);
    // }
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!whiteLocaleList.includes(locale as string)) {
            router.push(`/${locale}/404`);
        }
    }, []);

    return (
        <>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={productMsg.url} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name || 'EcoFlow 100W Rigid Solar Panel'}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon />
                    <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={isMobile ? {} : { width: '1120px' }} />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}
